define(["require", "exports", "tslib", "mobx", "../../store/UserStore", "../domain"], function (require, exports, tslib_1, mobx_1, UserStore_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpApproval = void 0;
    class FWpApproval {
        constructor(wp) {
            Object.defineProperty(this, "wp", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusPreWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cancellableStates", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    domain_1.FacilityWpStatusDomain.Eoi,
                    domain_1.FacilityWpStatusDomain.ProvisionallyApproved,
                    domain_1.FacilityWpStatusDomain.Quoted,
                    domain_1.FacilityWpStatusDomain.Approved
                ]
            });
            Object.defineProperty(this, "ApproveDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsApproveEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CanUserCaptureApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CancelDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsCancelEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ReverseCancellationDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsReverseCancellationEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.wp = wp;
            this.evaluateStatus();
            this.statusWatcher = (0, mobx_1.observe)(this.wp, "Status", x => {
                this.evaluateStatus();
            });
            this.statusPreWatcher = (0, mobx_1.observe)(this.wp, "StatusPrev", x => {
                this.evaluateStatus();
            });
        }
        evaluateStatus() {
            this.deriveApproveWorksState();
            this.deriveCancelWorksState();
            this.deriveReverseCancelWorksState();
        }
        get ActiveStatus() {
            if (this.wp.StatusReq && !isNaN(this.wp.StatusReq)) {
                return this.wp.StatusReq;
            }
            else {
                return this.wp.Status;
            }
        }
        approveWorks() {
            switch (this.wp.Status) {
                case domain_1.FacilityWpStatusDomain.Draft:
                    if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                        this.setStatus(domain_1.FacilityWpStatusDomain.Completed);
                    }
                    else {
                        this.setStatus(domain_1.FacilityWpStatusDomain.Eoi);
                    }
                    break;
                case domain_1.FacilityWpStatusDomain.Eoi:
                    this.setStatus(domain_1.FacilityWpStatusDomain.ProvisionallyApproved);
                    break;
                case domain_1.FacilityWpStatusDomain.ProvisionallyApproved:
                    this.setStatus(domain_1.FacilityWpStatusDomain.Quoted);
                    break;
                case domain_1.FacilityWpStatusDomain.Quoted:
                    this.setStatus(domain_1.FacilityWpStatusDomain.Approved);
                    break;
                case domain_1.FacilityWpStatusDomain.Approved:
                    this.setStatus(domain_1.FacilityWpStatusDomain.Claimed);
                    break;
                case domain_1.FacilityWpStatusDomain.Claimed:
                    this.setStatus(domain_1.FacilityWpStatusDomain.Completed);
                    break;
                case domain_1.FacilityWpStatusDomain.Completed:
                    throw new Error("Can not promote a Works Project that is in a completed state");
                case domain_1.FacilityWpStatusDomain.Withdrawn:
                    throw new Error("Can not promote a Works Project that is in a withdrawn state");
                case domain_1.FacilityWpStatusDomain.NotApproved:
                    throw new Error("Can not promote a Works Project that is not approved");
                default:
                    throw new Error("Unknown Works Status");
            }
            this.evaluateStatus();
        }
        cancelWorks() {
            let userCancelType = domain_1.FacilityWpStatusDomain.Withdrawn;
            if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                userCancelType = domain_1.FacilityWpStatusDomain.NotApproved;
            }
            if (this.wp.Status == domain_1.FacilityWpStatusDomain.Draft) {
                this.setStatus(userCancelType);
            }
            else if (this.wp.Status == domain_1.FacilityWpStatusDomain.Eoi) {
                this.setStatus(userCancelType);
            }
            else if (this.wp.Status == domain_1.FacilityWpStatusDomain.ProvisionallyApproved) {
                this.setStatus(userCancelType);
            }
            else if (this.wp.Status == domain_1.FacilityWpStatusDomain.Quoted) {
                this.setStatus(userCancelType);
            }
            else if (this.wp.Status == domain_1.FacilityWpStatusDomain.Approved) {
                this.setStatus(userCancelType);
            }
            else {
                throw new Error(`A Works Project with a status of ${this.wp.Status} can not be cancelled.`);
            }
            this.evaluateStatus();
        }
        reverseCancellationOfWorks() {
            if (this.wp.Status == domain_1.FacilityWpStatusDomain.Withdrawn && this.isCancellable(this.wp.StatusPrev)) {
                this.setStatus(this.wp.StatusPrev);
            }
            else if (this.wp.Status == domain_1.FacilityWpStatusDomain.NotApproved && this.isCancellable(this.wp.StatusPrev)) {
                this.setStatus(this.wp.StatusPrev);
            }
            else {
                throw new Error(`A Works Project with a status of ${this.wp.Status} can not be reversed.`);
            }
            this.evaluateStatus();
        }
        isCancellable(statusOfInterest) {
            return this.cancellableStates.indexOf(statusOfInterest) > -1;
        }
        deriveApproveWorksState() {
            this.ApproveDesc = "Approve";
            if (this.wp.Facility && this.wp.Facility.IsUserPriviledgedToEdit) {
                switch (this.wp.Status) {
                    case domain_1.FacilityWpStatusDomain.Draft:
                        this.ApproveDesc = "Submit Expression of Interest";
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.ApproveDesc = "Works Completed";
                        }
                        this.IsApproveEnabled = true;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.FacilityWpStatusDomain.Eoi:
                        this.ApproveDesc = "Provisionally Approve";
                        this.CanUserCaptureApprovalComment = true;
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsApproveEnabled = true;
                        }
                        else {
                            this.IsApproveEnabled = false;
                        }
                        break;
                    case domain_1.FacilityWpStatusDomain.ProvisionallyApproved:
                        this.ApproveDesc = "Assess Quotes";
                        this.CanUserCaptureApprovalComment = true;
                        this.IsApproveEnabled = true;
                        break;
                    case domain_1.FacilityWpStatusDomain.Quoted:
                        this.ApproveDesc = "Approve Quote";
                        this.CanUserCaptureApprovalComment = true;
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsApproveEnabled = true;
                        }
                        else {
                            this.IsApproveEnabled = false;
                        }
                        break;
                    case domain_1.FacilityWpStatusDomain.Approved:
                        this.ApproveDesc = "Proceed with Claim";
                        this.CanUserCaptureApprovalComment = true;
                        this.IsApproveEnabled = true;
                        break;
                    case domain_1.FacilityWpStatusDomain.Claimed:
                        this.ApproveDesc = "Works Completed";
                        this.CanUserCaptureApprovalComment = true;
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsApproveEnabled = true;
                        }
                        else {
                            this.IsApproveEnabled = false;
                        }
                        break;
                    case domain_1.FacilityWpStatusDomain.Withdrawn:
                        this.ApproveDesc = "Works Withdrawn";
                        this.CanUserCaptureApprovalComment = false;
                        this.IsApproveEnabled = false;
                        break;
                    case domain_1.FacilityWpStatusDomain.Completed:
                        this.ApproveDesc = "Works Completed";
                        this.CanUserCaptureApprovalComment = false;
                        this.IsApproveEnabled = false;
                        break;
                    case domain_1.FacilityWpStatusDomain.NotApproved:
                        this.ApproveDesc = "Works Not Approved";
                        this.CanUserCaptureApprovalComment = false;
                        this.IsApproveEnabled = false;
                        break;
                    default:
                        throw new Error("Unknown Works Project Status");
                }
            }
            else {
                this.IsApproveEnabled = false;
                this.CanUserCaptureApprovalComment = false;
            }
        }
        deriveCancelWorksState() {
            this.CancelDesc = "Withdraw";
            if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                this.CancelDesc = "Disapprove";
            }
            if (this.wp.Facility && this.wp.Facility.IsUserPriviledgedToEdit) {
                switch (this.wp.Status) {
                    case domain_1.FacilityWpStatusDomain.Draft:
                        this.IsCancelEnabled = false;
                        break;
                    case domain_1.FacilityWpStatusDomain.Eoi:
                    case domain_1.FacilityWpStatusDomain.Quoted:
                    case domain_1.FacilityWpStatusDomain.ProvisionallyApproved:
                    case domain_1.FacilityWpStatusDomain.Approved:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.FacilityWpStatusDomain.Claimed:
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsCancelEnabled = true;
                        }
                        else {
                            this.IsCancelEnabled = false;
                        }
                        break;
                    default:
                        this.IsCancelEnabled = false;
                }
            }
            else {
                this.IsCancelEnabled = false;
            }
        }
        deriveReverseCancelWorksState() {
            this.ReverseCancellationDesc = "Reverse Cancellation";
            this.IsReverseCancellationEnabled = false;
            if (this.wp.Status == domain_1.FacilityWpStatusDomain.Withdrawn) {
                this.ReverseCancellationDesc = "Reverse 'Withdraw' Decision";
                this.IsReverseCancellationEnabled = true;
            }
            if (this.wp.Status == domain_1.FacilityWpStatusDomain.NotApproved) {
                this.ReverseCancellationDesc = "Reverse 'Disapprove' Decision";
                this.IsReverseCancellationEnabled = true;
            }
        }
        restoreLicenseToOriginalStatus() {
            this.wp.StatusReq = NaN;
            this.evaluateStatus();
        }
        setStatus(status) {
            this.wp.StatusReq = status;
        }
    }
    exports.FWpApproval = FWpApproval;
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "ApproveDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "IsApproveEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "CanUserCaptureApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "CancelDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "IsCancelEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "ReverseCancellationDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpApproval.prototype, "IsReverseCancellationEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpApproval.prototype, "ActiveStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpApproval.prototype, "deriveApproveWorksState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpApproval.prototype, "deriveCancelWorksState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpApproval.prototype, "deriveReverseCancelWorksState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpApproval.prototype, "restoreLicenseToOriginalStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpApproval.prototype, "setStatus", null);
});
